import { useStyles } from '@team-griffin/stylr';
import { gu2px, Theme, Colorway } from '@uds/theme-utils';
import { useBreakpoints } from '@ux/responsive';
import { CTA } from 'core/ribbons/cta';
import { css } from 'linaria';

export const getClassNames = () => {
  return {
    root: css`
      display: flex;
    `,
  };
};
export default ({ theme: { spacing }, ctas }: { theme: Theme; colorway: Colorway; ctas?: Array<CTA> }) => {
  const { isMinSm, isMinLg } = useBreakpoints();
  const hasMultipleCtas = (ctas ?? []).length > 1;

  return useStyles(
    {
      default: {
        content: {
          marginLeft: gu2px(3, spacing),
          flex: 1,
          flexBasis: 'auto',
          overflow: 'hidden',
          wordWrap: 'break-word',
        },
        illustration: {
          width: gu2px(10, spacing),
        },
        imageContainer: {
          width: gu2px(10, spacing),
          overflow: 'hidden',
        },
        image: {
          height: gu2px(10, spacing),
          position: 'relative',
          left: '50%',
          transform: 'translateX(-50%)',
        },
        ctas: {
          overflow: 'hidden',
          marginTop: gu2px(2, spacing),
        },
        cta: {
          marginTop: gu2px(1, spacing),
        },
      },

      isMinSm: {
        illustration: {
          width: gu2px(14, spacing),
        },
        imageContainer: {
          width: gu2px(14, spacing),
          overflow: 'hidden',
        },
        image: {
          height: gu2px(14, spacing),
        },
      },

      isMinLg: {
        illustration: {
          width: gu2px(16, spacing),
        },
        imageContainer: {
          width: gu2px(16, spacing),
          overflow: 'hidden',
        },
        image: {
          height: gu2px(16, spacing),
        },
        content: {
          marginLeft: gu2px(4, spacing),
        },
      },
      spaceCtas: {
        cta: {
          marginRight: gu2px(1, spacing),
          display: 'inline-block',
        },
      },
    },
    {
      isMinSm,
      isMinLg,
      spaceCtas: isMinSm && hasMultipleCtas,
    },
  );
};
